// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"52":"9a4cfb23","728":"3659f6bf","750":"3659f6bf","821":"3659f6bf","929":"3659f6bf","966":"74f30e3e"}[chunkId] + ".css";
};